<template>
<div>
    <Nav />
      <div class="pageWD shadowBox mT20 minHeight">
        <div class="pheader flex flex-sb" style="box-shadow:none">
           <img src="@/assets/images/xuexijihua.png" style="width:186px; height:58px" />         
        </div>
        <div class="flex task_tab">
          <div class="item " :class="[currentIndex=='1'?'tab1_active':'tab1_normal']"  @click="clickMe('1','allNum')">            
              <span :class="[currentIndex=='1'?'clolorMe':'']">{{allNum}}</span>
          </div>
           <div class="item " :class="[currentIndex=='2'?'tab2_active':'tab2_normal']" @click="clickMe('2','unover')">           
              <span :class="[currentIndex=='2'?'clolorMe':'']">{{unover}}</span>
          </div>
           <!-- <div class="item " :class="[currentIndex=='3'?'tab3_active':'tab3_normal']"  @click="clickMe('3')">   
              <span :class="[currentIndex=='3'?'clolorMe':'']">{{undone}}</span>
          </div> -->
           <div class="item " :class="[currentIndex=='3'?'tab3_active':'tab3_normal']"  @click="clickMe('3','done')">           
              <span :class="[currentIndex=='3'?'clolorMe':'']">{{done}}</span>
          </div>
        </div>
        <div style="height:24px"></div>
        <div class="task_list" v-if="taskList.length > 0">
            <div v-for="(item,index) in taskList" :key="index" >
            <TaskItem :item="item" />           
            </div>
        </div>
        <div v-else>
            <Empty />
        </div>  
      </div>
</div>
<!-- <router-view></router-view> :style="{'animation-name':(index==courseIndex?'upMove':'downMove')}"-->
</template>
<script>
import Cookies from "js-cookie";
import Nav from "@/components/Nav.vue";
import { getStudyTask  } from '@/api/api'
import Empty from "@/components/Empty.vue";
import TaskItem from "./components/TaskItem.vue";
  export default {
    components: { Nav , Empty, TaskItem},
    data() {
        return {
            currentIndex:'1', 
            taskList:[],
            tabNum:'allNum',
            allNum: '',
            done:  '',
            undone: '',
            unover:''
        }
    },
    created() {
        this.getStudyTaskFun()//获取课程分类
    },
    methods: { 
        clickMe(currentIndex,type){
           this.currentIndex = currentIndex
           this.tabNum = type
        },
        getStudyTaskFun() {
          var that = this;
          let data = {
              memberId: Cookies.get('qslmemberId'),
              COID: Cookies.get('qslCOID'),
              pageIndex: 1,
              pageSize: 50             
          };
          getStudyTask(data)
              .then(res => {
                  console.log( res.body.result) 
                  that.taskList = res.body.result.taskList;  
                  that.allNum = res.body.result.memberTaskNum.allNum;   
                  that.done = res.body.result.memberTaskNum.done; //已完成
                  that.unover = res.body.result.memberTaskNum.allNum - res.body.result.memberTaskNum.done;    //未完成                    
                 // that.filterFun(that.taskList,type)
                 
              })
              .catch(err => {});
        }
        // filterFun(list,type){
        //     if(type=='allNum'){
                
        //     }
        //     if(type=='done'){
                
        //     }
        //     if(type=='unover'){
                
        //     }
        //     console.log(type)
        // }
    }
}   
</script>

<style scoped>
.task_tab .item{
    width:368px; 
    height:110px    ;
    margin-left:23px;
    display:block;
    position:relative;
    border-radius:8px
}
.task_tab .item:hover{
    box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.2);
    top:-4px;
    cursor: pointer;
}
.tab1_normal{
    background:url('../../assets/images/task/quanbu_t_n.png')
}
.tab2_normal{
    background:url('../../assets/images/task/weiwanchengi_t_n.png')
}
.tab3_normal{
    background:url('../../assets/images/task/yiwancheng_t_n.png')
}

.tab1_active{
    background:url('../../assets/images/task/quanbu_t_o.png')
}
.tab2_active{
    background:url('../../assets/images/task/weiwancheng_t_o.png')
}
.tab3_active{
    background:url('../../assets/images/task/yiwancheng_t_o.png')
}

.task_tab .item span{
    position:absolute;
    bottom:20px;
    right:24px;
    font-size:32px;
    color:#fff
}
.task_tab .item span.clolorMe{
    color:#000
}

</style>


// WEBPACK FOOTER //
// src/views/Task/index.vue